import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './ButtonSelector.scss';
import Spinner from '../../utils/Spinner';
import Ripple from '../../utils/Ripple';
import translatePropTypes from '../../../translatePropTypes';
import withTranslations from '../../utils/Translations/withTranslations';
import helpNoteTitleIfPresent from '../../utils/Translations/helpNoteTitleIfPresent';
import { isRTL } from '../../../utils/commonHelper';

@withTranslations
export default class ButtonSelector extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    valueTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    emptyValueTitle: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    hasMarginLeft: PropTypes.bool,
    dataCy: PropTypes.string,
    ...translatePropTypes,
  };

  static defaultProps = {
    valueTitle: null,
    className: null,
    emptyValueTitle: null,
    disabled: false,
    loading: false,
    hasMarginLeft: true,
    dataCy: '',
  };

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();

    const { disabled, onClick } = this.props;

    if (!disabled) {
      onClick();
    }
  };

  render() {
    const {
      t,
      getHelpNoteTooltipTitle,
      title,
      valueTitle,
      emptyValueTitle,
      className,
      disabled,
      loading,
      hasMarginLeft,
      dataCy,
      isLayoutRTL,
    } = this.props;

    const linkClassName = classnames(className, styles.link, {
      'cursor-pointer': !disabled,
      [styles.disabled]: disabled,
    });

    const valueStyle = classnames('button-selector-value', styles.valueStyle, {
      [styles.value]: hasMarginLeft,
    });
    const emptyValueStyle = isRTL(emptyValueTitle || t('None'))
      ? `${valueStyle} ${styles.emptyValueRTL}`
      : `${valueStyle} ${styles.emptyValue}`;

    const showValueTitle = valueTitle && !loading;
    const showEmptyTitle = !valueTitle && !loading;

    const link = (
      <a className={linkClassName} data-cy={dataCy} onClick={this.handleClick}>
        <span
          className={classnames('text-semibold', {
            'mr-5': !hasMarginLeft && !isLayoutRTL,
            'ml-5': !hasMarginLeft && isLayoutRTL,
          })}
          title={helpNoteTitleIfPresent(getHelpNoteTooltipTitle, title)}
        >
          {title}:
        </span>

        {showValueTitle && <span className={valueStyle}>{valueTitle}</span>}

        {showEmptyTitle && (
          <span className={emptyValueStyle}>
            {emptyValueTitle || t('None')}
          </span>
        )}

        {loading && <Spinner className={styles.loading} />}
      </a>
    );

    return disabled ? link : <Ripple>{link}</Ripple>;
  }
}
